import * as cmn from "../common/NamaCommon";
import {ajaxJSONWithoutWait} from "../common/NamaCommon";
import * as NamaURLS from '../constants/NamaURLS';
import * as ViewMode from '../constants/ViewMode';
import {getAllEntityTypes, mustSelectEntityInSearchInBeforeSearchOnServer, shouldShowSearchInForTopPanel} from "../login/ClientCache";
import {isArabic, translateId, translateIdAr, translateIdEn, translateRef} from "../common/Translator";
import {EditPlace, EntityListPlace} from "../routing/places";
import {NamaRouterInstance} from "../routing/NamaRouter";
import {findFieldAndHighLightIt} from "../common/ErrorsNotification";
import * as StringUtils from '../common/StringUtils';
import {NamaGridWidget} from "../grid/NamaGridWidget";

const MAX_FIELDS = 100;

function handleAutoCompleteKeyDownAndDblClick(that, autoComplete, element) {
    autoComplete.list.css("min-width", 300);
    that.startSearch = function () {
        if (that.active)
            return;
        autoComplete.search(autoComplete.value());
    }
    element.on("keyup", (e) => {
        if (kendo.keys.DOWN == e.keyCode)
            that.startSearch();
    });
    element.on("dblclick", (e) => {
        that.startSearch();
    });
}

export function initTopPanelSearchSuggestOracle(element) {
    let that = {};
    /**
     *
     * @type {kendo.ui.AutoComplete}
     */
    let autoComplete = element.kendoAutoComplete({
        placeholder: translateId("searchHelp"),
        highlightFirst: true,
        filter: "contains",
        dataSource: {
            transport: {
                read: (options) => {
                    let textToSearch = autoComplete.value();
                    if (textToSearch && (textToSearch.toLowerCase().startsWith("f:") || textToSearch.toLowerCase().startsWith("p:")
                        || textToSearch.startsWith("ح:") || textToSearch.startsWith("ب:"))) {
                        let presenter = NamaRouterInstance.currentPresenter;
                        if (presenter.calcPresenterFields) {
                            let fieldSearchSuggestionItems = presenter.calcPresenterFields();
                            let fieldsList = suggestFromFields(textToSearch, fieldSearchSuggestionItems);
                            if (fieldsList) {
                                let listToDisplay = prepareList(fieldsList);
                                options.success({
                                    data: listToDisplay,
                                    total: listToDisplay.length
                                });
                            }
                        }
                    } else {
                        searchFor(textToSearch, options, autoComplete, false);
                    }
                }
            },
            serverFiltering: true,
            serverPaging: true,
            schema: {
                data: "data", total: "total"
            },
            pageSize: 25,
        },
        dataTextField: "text",
        open: (e) => {
            that.active = true;
        },
        close: (e) => {
            that.active = false;
        },
        select: (e) => {
            handleSelection(e.dataItem);
            setTimeout(() => {
                autoComplete.close();
                autoComplete.value("");
            })
        }
    }).data("kendoAutoComplete");
    handleAutoCompleteKeyDownAndDblClick(that, autoComplete, element);
}

let selectedSearchInItem;
let searchInAutoComplete;

export function initTopPanelSearchInSuggestOracle(element) {
    if (!shouldShowSearchInForTopPanel()) {
        element.attr("style", "display: none !important");
        return;
    }
    let that = {};
    /**
     *
     * @type {kendo.ui.AutoComplete}
     */
    let autoComplete = searchInAutoComplete = element.kendoAutoComplete({
        placeholder: translateId("searchInHelp"),
        highlightFirst: true,
        filter: "contains",
        dataSource: {
            transport: {
                read: (options) => {
                    let textToSearch = autoComplete.value();
                    searchFor(textToSearch, options, autoComplete, true);
                }
            },
            serverFiltering: true,
            serverPaging: true,
            schema: {
                data: "data", total: "total"
            },
            pageSize: 25,
        },
        dataTextField: "text",
        select: (e) => {
            selectedSearchInItem = e.dataItem;
            setTimeout(() => {
                autoComplete.close();
            })
        }, open: (e) => {
            that.active = true;
        },
        close: (e) => {
            that.active = false;
        }
    }).data("kendoAutoComplete");
    handleAutoCompleteKeyDownAndDblClick(that, autoComplete, element);
}

export function getSelectedSearchIn() {
    if (!searchInAutoComplete)
        return null;
    if (!searchInAutoComplete.value())
        return null;
    if (!selectedSearchInItem)
        return null;
    return selectedSearchInItem.id;
}

function prepareList(list) {
    let listToDisplay = [];
    for (let item of list) {
        let fieldName = isArabic() ? item.arabic : item.english;
        listToDisplay.push({
            text: fieldName + "(" + item.id + ")",
            pageIndex: item.pageIndex,
            widgetElementId: item.widget.elementId,
            widgetHighlightKlass: item.widget instanceof NamaGridWidget ? "k-grid-header" : "form-group",
            thGridId: $(item.widget[0]).is("th") ? $(item.widget[0]).closest(".k-grid").attr("id") : undefined,
            thFieldId: $(item.widget[0]).is("th") ? $(item.widget[0]).attr("data-field") : undefined
        });
    }
    return listToDisplay;
}

function suggestFromFields(textToSearch, fieldSearchSuggestionItems) {
    let list = [];
    let query = cmn.substringAfter(textToSearch, ":");
    let queryToLower = query.toLowerCase();
    let arNormailized = StringUtils.normalizeArabic(query);
    let enToArNormalized = StringUtils.normalizeArabic(StringUtils.englishToArabic(query));
    let arToEn = StringUtils.arabicToEnglish(query).toLowerCase();
    for (let item of fieldSearchSuggestionItems) {
        if (!item.searchData)
            fillSearchDataInFieldSearchSuggestionItem(item);
        if (matchesUsingNormalization(item.searchData, queryToLower, arNormailized, enToArNormalized, arToEn))
            list.push(item);
        if (list.length >= MAX_FIELDS)
            return list;
    }
    return list;
}

export function fillSearchDataInFieldSearchSuggestionItem(s) {
    if (!s)
        return;
    let id = s.id || "";
    let arabic = s.arabic || "";
    let english = s.english || "";
    s.searchData = id.toLowerCase() + " " + arabic.toLowerCase() + " " + StringUtils.normalizeArabic(arabic.toLowerCase()) + " "
        + english.toLowerCase();
}

export function matchesUsingNormalization(searchData, query, arNormalized, enToArNormalized, arToEn) {
    if (searchData == null || searchData == undefined)
        return false;
    searchData = searchData.toLowerCase();
    return searchData.contains(query) || searchData.contains(arNormalized) ||
        searchData.contains(enToArNormalized) || searchData.contains(arToEn);
}

/**
 *
 * @param {string} text
 * @param {kendo.data.DataSourceTransportOptions} option
 * @param {kendo.ui.AutoComplete} autoComplete
 * @param {boolean} forEntitiesOnly
 */
function searchFor(text, options, autoComplete, forEntitiesOnly) {
    initEntitiesIfNeeded();
    text = text.toLowerCase();
    if (!getSelectedSearchIn()) {
        let matchingEntities = entities.filter((e) => {
            return e.searchData.contains(text.toLowerCase()) || e.searchData.contains(StringUtils.normalizeArabic(text)) || e.searchData
                .contains(StringUtils.normalizeArabic(StringUtils.englishToArabic(text))) || e.searchData.contains(StringUtils.arabicToEnglish(text).toLowerCase());
        })
        if (matchingEntities.length || forEntitiesOnly) {
            options.success({data: matchingEntities, total: matchingEntities.length})
            return;
        }
    }
    if (mustSelectEntityInSearchInBeforeSearchOnServer() && !getSelectedSearchIn()) {
        options.success({data: [], total: 0})
        return;
    }
    if (getSelectedSearchIn())
        text = getSelectedSearchIn() + ":" + text;
    /**
     *
     * @type {namaTypes.DTOSearchAll}
     */
    let request = {
        pageSize: autoComplete.dataSource.pageSize(),
        startPage: autoComplete.dataSource.page() - 1,
        query: text
    };
    ajaxJSONWithoutWait(NamaURLS.SEARCH_ALL, {request: JSON.stringify(request)},
        (data) => {
            let convertedData = [];
            if (data.page)
                convertedData = data.page.map((ref) => {
                    return {record: ref, type: "record", text: translateId(ref.entityType) + ": " + translateRef(ref)}
                });
            options.success({
                data: convertedData,
                total: data.totalRecordsCount
            })
        },
        (error) => {
            options.error();
        });

}

let entities = [];
let itemsForEntitiesOnly = [];

function initEntitiesIfNeeded() {
    if (entities.length)
        return;
    entities = [];
    itemsForEntitiesOnly = [];
    for (let entity of getAllEntityTypes()) {
        let obj = {
            id: entity,
            ar: translateIdAr(entity),
            en: translateIdEn(entity),
            type: "entity",
            text: translateId(entity)
        };
        obj.searchData = obj.id.toLowerCase() + " " + obj.ar.toLowerCase() + " " + StringUtils.normalizeArabic(obj.ar.toLowerCase()) + " " +
            translateIdAr(entity + "s").toLowerCase() + " " + StringUtils.normalizeArabic(translateIdAr(entity + "s").toLowerCase()) + " " +
            obj.en.toLowerCase() + " " + translateIdEn(entity + "s").toLowerCase();
        entities.push(obj)
    }
}

function handleSelection(selection) {
    if (selection.type === "entity") {
        let place = new EntityListPlace()
        place.entityType = selection.id;
        NamaRouterInstance.goTo(place);
    } else if (selection.type === "record") {
        let place = new EditPlace();
        place.view = ViewMode.EDIT;
        place.entityType = selection.record.entityType;
        place.id = selection.record.id;
        NamaRouterInstance.goTo(place);
    } else if (selection.text) {
        let textBefore = cmn.substringBefore(selection.text, ")");
        let id = cmn.substringAfter(textBefore, "(");
        let widgetPageIndex = selection.pageIndex;
        let widgetElementId = selection.widgetElementId || selection.thGridId;
        let widgetHighlightKlass = selection.widgetHighlightKlass;
        if (!widgetElementId) {
            widgetElementId = id;
            widgetHighlightKlass = undefined;
        }
        let presenter = NamaRouterInstance.currentPresenter;
        let ele = presenter.view.find("#" + widgetElementId);
        let element = ele;
        if (widgetHighlightKlass)
            element = widgetHighlightKlass == "form-group" ? ele.closest("." + widgetHighlightKlass) : ele.find("." + widgetHighlightKlass);
        let thFieldId = selection.thFieldId;
        if (thFieldId)
            element = ele.find("th[data-field='" + thFieldId + "']");
        findFieldAndHighLightIt(id, -1, presenter, widgetPageIndex, element);
    }
}